import axios from 'axios'
import VueCookie from 'vue-cookie'
import qs from 'qs'
import router from "@/router";
import { Loading, Message } from 'element-ui';
let loadingInstance = null;
import _ from 'lodash';

// if (process.env.NODE_ENV === 'production') {
//     axios.defaults.baseURL = 'http://rentafter.dev.hzfapi.com/rentafter/'
// }
axios.defaults.baseURL = URL_PREFIX_SERVICE
// 请求超时配置
axios.defaults.timeout = 30 * 1000

// 状态码配置
axios.defaults.validateStatus = function (status) {
    return status == 200
}

// 默认请求头
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'

// 请求拦截器
axios.interceptors.request.use(
    config => {
        if (config.url === '/pc/common/verificationcode/' || config.url === '/pc/common/verification/' || config.url === '/pc/user/sendcode/' || config.url === '/pc/system/reqcitylist/') {

        } else {
            loadingInstance = Loading.service({ fullscreen: true });
        }
        // 在发送请求之前做些什么
        config.data = config.data || {}
        if (config.url === '/pc/user/loginbefore/' || config.url === '/pc/user/login/' || config.url == '/share/order/h5reqorderinfo/') {

        } else {
            Object.assign(config.data, {token: VueCookie.get('token')})
        }
        if (typeof config.data === 'object') {
            config.data = qs.stringify(config.data)
        }
        return config
    }, error => {
        // 对请求错误做些什么
        return Promise.reject(error)
    })

axios.interceptors.response.use(
    res => {
        if (res.status == 200) {
            // if (res.config.url === '/pc/pc/common/verification/') {
            //     console.log(res, '333')
            //     loadingInstance.close();
            //     return res.data
            // }
            // console.log(res, 'bbb')
            if (res.data.status.code === "07320001") {
                router.push('/')
            } 
        }
        if (loadingInstance) {
            loadingInstance.close();
        }
        return res.data
    },
    error => {
        // 请求错误时做些事
        if (loadingInstance) {
            loadingInstance.close();
        }
        return Promise.reject(error)
    })

let vue = null;

export default axios



// WEBPACK FOOTER //
// ./src/api/axios.js